<template>
  <div v-if="totalOptions > 1" class="w-96">
    <VSelect
      v-model="projectId"
      :options="projectOptions"
      label="name"
      :reduce="(projectOption) => projectOption.uuid"
      class="vue-select custom-option"
      :filterable="false"
      placeholder="Filter by project"
      @search="onSearch"
    >
      <template #option="{ name }">
        <span class="block truncate">{{ name }}</span>
      </template>
      <template v-if="hasMore" #list-footer>
        <li class="flex space-x-2 mt-2">
          <BaseButton
            primary
            outline
            small
            :disabled="!hasPrevPage"
            class="flex-1"
            @click="fetchPrevPage"
          >
            Prev
          </BaseButton>
          <BaseButton
            primary
            outline
            small
            :disabled="!hasNextPage"
            class="flex-1"
            @click="fetchNextPage"
          >
            Next
          </BaseButton>
        </li>
      </template>
      <template #no-options>
        <div class="p-4">No projects found.</div>
      </template>
    </VSelect>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import { getAccountProjectListApi } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    pipelineId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      project: null,
      projectOptions: [],
      meta: null,
      search: '',
      page: 1,
    };
  },
  computed: {
    projectId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    totalOptions() {
      return this.meta?.total || 0;
    },
    hasMore() {
      return (this.meta?.total || 0) > (this.meta?.per_page || 0);
    },
    hasPrevPage() {
      return (this.meta?.current_page || 1) > 1;
    },
    hasNextPage() {
      return (this.meta?.last_page || 1) > (this.meta?.current_page || 1);
    },
  },
  created() {
    this.fetchProjects();
  },
  methods: {
    onSearch(search, loading) {
      loading(true);
      this.searchOptions(loading, search, this);
    },
    searchOptions: debounce((loading, search, vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.search = search;
      // eslint-disable-next-line no-param-reassign
      vm.page = 1;
      vm.fetchProjects().finally(() => loading(false));
    }, 350),
    async fetchProjects() {
      try {
        const response = await getAccountProjectListApi(this.accountId, {
          filter: {
            search: this.search,
            has_contact_requests_on_pipeline_id: this.pipelineId,
          },
          page: this.page,
        });

        this.projectOptions = response.data.data;
        this.meta = response.data.meta;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    fetchPrevPage() {
      if (!this.hasPrevPage) {
        return;
      }
      this.page = this.meta.current_page - 1;
      this.fetchProjects();
    },
    fetchNextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.page = this.meta.current_page + 1;
      this.fetchProjects();
    },
  },
};
</script>
